module.exports = __webpack_public_path__ + "img/Group 3921.68ceec55.svg";